import { render, staticRenderFns } from "./CommunityCitySanjaeCard.vue?vue&type=template&id=34c704ac&scoped=true"
import script from "./CommunityCitySanjaeCard.vue?vue&type=script&lang=js"
export * from "./CommunityCitySanjaeCard.vue?vue&type=script&lang=js"
import style0 from "./CommunityCitySanjaeCard.vue?vue&type=style&index=0&id=34c704ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c704ac",
  null
  
)

export default component.exports